import styled from 'styled-components'
import { media } from '@popety-io/ui'

export const ContentWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.large};

  ${media.mobileOnly} {
    padding: 0 ${({ theme }) => theme.spacing.medium}
      ${({ theme }) => theme.spacing.medium}
      ${({ theme }) => theme.spacing.medium};
  }
`

export const ChartContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};

  ${media.mobileOnly} {
    margin-bottom: ${({ theme }) => theme.spacing.large};
  }
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spacing.large};
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};

  ${media.desktopDown} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.mobileOnly} {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.medium};
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.huge} 0;
  text-align: center;
`

export const EmptyStateIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing.large};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const EmptyStateTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
`

export const EmptyStateText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  max-width: 400px;
`
